<div style="width:auto;background:#7f96ac;;height: 35px;margin-bottom: 10px;">
  <span style="line-height: 35px;color:#fff;padding-left:40%">{{"PASSAGES"|translate}}</span>
  <div style="background: #9eacb4;padding: 5px;height:35px;width:30%;float:right;padding-right:20px">

    <button *ngIf="infoproget" type="button" class="btn  flex-box y-center tabMenuBtnNew filterDropdown"
            aria-haspopup="true"
            style="
    background-color: #0a6aa1;
    border: 1px solid;
    font-size: 10px;
    padding: 5px 10px 3px 10px;
    margin-left: 80px;
    margin-top: 0;
    color:#ffffff;
float:right
    ">
       <span class="levelListButton"><a style="color:#ffffff;text-decoration:none"
                                        href="http://safewtraffic.infoproget.com/"
                                        target="_blank">{{"ACCESS_TO_SAFE_TRAFFIC"|translate}}</a></span>
    </button>
  </div>


</div>
<app-progressbar *ngIf="isLoading"></app-progressbar>
<table mat-table matSort matSortStart="desc" [dataSource]="passagesList" matSortDisableClear="true" class="noRowBorder"
       style="width: 100%">
  <ng-container matColumnDef="View">
    <th mat-header-cell *matHeaderCellDef mat-sort-header
        disableClear="true">{{"VIEW"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold"
        (click)="openMedia('pdf', element.UniqueID)" style="cursor: pointer">
      <fa-icon [icon]="iconService.faEye"></fa-icon>
    </td>
  </ng-container>
  <ng-container matColumnDef="UniqueID">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="">Id
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">{{element.UniqueID}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Threshold">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="">
      Threshold
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
      -
    </td>
  </ng-container>
  <ng-container matColumnDef="Date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"DATE"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
      {{element.Date}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Hour">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"TIME"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
      {{element.Hour}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Direction">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"DIRECTION"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold" style="max-width: 80px">
      {{element.Direction}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Axles">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"AXLES"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
      {{element.Axles}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Length">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"LENGTH"|translate}} (m)
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
      {{element.Length}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Speed">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"SPEED"|translate}} (km/h)
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
      {{element.Speed}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Weight">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"WEIGHT"|translate}} (t)
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
      {{element.Weight}}
    </td>
  </ng-container>
  <ng-container matColumnDef="Plate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"PLATE"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
            <span *ngIf="element.Plate && element.Plate.length > 0; else noPlate"
                  style="display: flex; flex-direction: column">
                <span *ngFor="let p of element.Plate">{{p.Plate}}</span>
            </span>
      <ng-template #noPlate>-
      </ng-template>
    </td>
  </ng-container>
  <ng-container matColumnDef="Image">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"IMAGE"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
            <span *ngIf="element.Image.length > 0; else noImage" style="cursor: pointer;"
                  (click)="openMedia('image', element.UniqueID)">
                    <fa-icon matSuffix [icon]="iconService.faImage"></fa-icon>
            </span>
      <ng-template #noImage>-
      </ng-template>
    </td>
  </ng-container>
  <ng-container matColumnDef="Video">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"VIDEO"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
            <span *ngIf="element.nbVideo > 0; else noVideo" style="cursor: pointer;"
                  (click)="openMedia('video', element.UniqueID)">
                    <fa-icon matSuffix [icon]="iconService.faVideo"></fa-icon>
            </span>
      <ng-template #noVideo>-
      </ng-template>
    </td>
  </ng-container>
  <ng-container matColumnDef="Confidence">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true"
        class="">{{"CONFIDENCE"|translate}}
    </th>
    <td mat-cell *matCellDef="let element" [ngClass]="element.userThreshold">
      {{element.Confidence}}
    </td>
  </ng-container>
  <div class="test">
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  </div>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator
  [pageSize]="10"
  [pageSizeOptions]="[10, 25, 50]">
</mat-paginator>
